'use client';

export default function TabHead({ data = [], activeType, callback }: any) {
    // 切换
    const toggleHandle = (item: any) => {
        callback && callback(item);
    };
    return (
        <div className="eco-tab-head">
            <div className="eco-tab-head-in">
                {data.map((item: any, index: number) => {
                    return (
                        <div
                            className={`eco-tab-head-item eco-tab-head-item-${index + 1}${activeType === item.value ? ' eco-tab-head-active' : ''}`}
                            key={index}
                            onClick={() => {
                                toggleHandle(item);
                            }}
                        >
                            {item.label}
                        </div>
                    );
                })}
                <div className="eco-tab-head-item-line"></div>
            </div>
        </div>
    );
}
